import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function OpToken(props) {
  const [appData, setAppData] = useState([]);
  const [hospData, setHospData] = useState([]);
  const [ageNew, setAgeNew] = useState(0);
  const [calculateAge, setCalculate] = useState([]);
  const { appt_id } = useParams();
  useEffect(() => {
    try {
      axios.get(baseUrl + "view-appointment/" + appt_id).then(function (response) {
        setAppData(response.data);
      });
    } catch (error) {
      console.log(error);
    }
    try {
      axios.get(baseUrl + "view-hospital/" + userLocation + "/").then(function (response) {
        setHospData(response.data);
      });
    } catch (error) {
      console.log(error);
    }
  }, []);
   const handlePrint = () => {
    const printContents = document.getElementById('invoice-print').innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    setTimeout(() => {
        window.location.reload();
    }, 1000);
    document.body.innerHTML = originalContents;
 };
// useEffect(() => {
// const calculateAgeFunc = (registrationDate) => {
//    const regDate = new Date(registrationDate)
//    const currentDate = new Date();
//    const ageInMilliseconds = currentDate - regDate;
//    const ageInYears = ageInMilliseconds / (365.25 * 24 * 60 * 60 * 1000);
//
//    const newAge  = Math.floor(ageInYears)
//
//    setAgeNew(newAge)
//    console.log(newAge)
//    };
//     const registrationDate = appData.pat.add_date;
//    calculateAgeFunc(registrationDate);
//  }, []);
//
//const updatePromises = appData.map(drug => {
//         const pharmData = {
//            age: (ageNew),
//            pat_id: drug.pat.pat_id,
//            ip_add: ipAddress,
//          };
//
//          return;
//          return axios.post(`${baseUrl}update-age/`, pharmData)
//          .then(response => {
//            console.log(response.data);
//          })
//          .catch(error => {
//            console.log(error);
//          });
//      });

  return (
    <section className="container mt-4">
      <h3 className="text-center" style={{ color: "black", backgroundColor: "#e5eaef" }}>
        <i className="fa-solid fa-qrcode" aria-hidden="true" style={{ color: "black" }}></i> Token Print
      </h3>
      <div className="row nurseInpatient">
        <div className="col-md-12" id="invoice-print">
          <table width="100%">
            <tbody>
              <tr>
                {hospData.map((hospital) => (
                  <td colspan="2" align="right">
                    <p align="center">
                      <strong>{hospital.hospital}</strong>
                      <br></br>Address&nbsp;: &nbsp;{hospital.address}
                    </p>
                  </td>
                ))}
              </tr>
              {appData.map((app) => (
                <>
                  <tr align="center">
                    <td style={{ fontWeight: "bold", paddingLeft: "18px" }}>Reg.On : {app.appt_date}</td>
                  </tr>
                  <tr align="center">
                    <td style={{ fontWeight: "bold" }}>{app.cons.consultant} &amp; {app.cons.department}</td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold", paddingLeft: "18px" }}>UHID : <b>{app.pat.pat_id}</b></td>
                    <td style={{ fontWeight: "bold" }}>Token No: {appData.length}</td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold", paddingLeft: "18px" }}>{app.pat.patient},</td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold", paddingLeft: "18px" }}>Age : {app.pat.age}/{app.pat.gender}</td>
                  </tr>
                 <tr><td style={{fontWeight: 'bold', paddingLeft: '18px',  paddingBottom: '30px'}}>Weight : <b></b></td></tr>
                 <tr><td style={{fontWeight: 'bold', paddingLeft: '18px',  paddingBottom: '30px'}}>BP : <b></b></td></tr>
                 <tr><td style={{fontWeight: 'bold', paddingLeft: '18px',  paddingBottom: '30px'}}>Temp : <b></b></td></tr>
                 <tr><td style={{fontWeight: 'bold', paddingLeft: '18px'}}>Addr. : <b>{app.pat.address1}</b></td></tr>
                 </>
                 ))}
             </tbody>
             </table>
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <button style={{ padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff' }}
              onClick={handlePrint}
              >
               Print
              </button>
            </div>
    </section>
  )
}

export default OpToken;
